import { GameUIConfig, GameConfig } from "../GameConfig/GameConfig.js";

export default class ScoreUI {
  constructor() {
    this.fontsize = GameConfig.UI.FONT_SIZE;
    this.fontFamily = GameConfig.UI.FONT_FAMILY;

    this.color = GameConfig.UI.COLOR;

    this.score = 0;
  }

  draw(context) {
    context.fillStyle = this.color;
    context.font = `${this.fontsize} ${this.fontFamily}`;
    context.fillText(
      `Score: ${this.score}`,
      GameUIConfig.SCORE.X,
      GameUIConfig.SCORE.Y,
    );
  }

  update(score) {
    this.score = score;
  }
}
